import type {CaseWaitParty} from "@indebted/api"

type WaitPartyPhrasing = {
	Label: string
	Description?: string
	Status: string
}

const phrasingByPartyID: Record<string, WaitPartyPhrasing> = {
	CUSTOMER: {
		Label: "Waiting on customer",
		Description: "The case waits until the customer comes back to us.",
		Status: "Waiting on customer",
	},
	CLIENT: {
		Label: "Escalate to the client",
		Description: "Opens a ticket with the client support team, and waits until they come back to us.",
		Status: "Escalated to the client",
	},
}

function phraseWaitParty(party: CaseWaitParty): WaitPartyPhrasing {
	return phrasingByPartyID[party.ID] ?? {Label: party.Label, Status: `Waiting on ${party.Label}`}
}

function phraseWaitStatusMidSentence(party: CaseWaitParty): string {
	const status = phraseWaitParty(party).Status
	return status.charAt(0).toLowerCase() + status.slice(1)
}

export {phraseWaitParty, phraseWaitStatusMidSentence}
